import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ListInstallationsMESAndInstallees } from 'src/app/model/call/call.model';
import { CallService } from 'src/app/services/http/call/call.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

@Component({
  selector: 'app-check-analysis',
  templateUrl: './check-analysis.component.html',
  styleUrls: ['./check-analysis.component.scss']
})
export class CheckAnalysisComponent implements OnInit {
  public form !: FormGroup;
  public loading: boolean = false;
  public data !: any;
  public list: any[] = [];

  get displayedColumns(): string[] {
    const result: string[] = ['ok', 'nok', 'user_login', 'mois'];
    return result;
  }

  constructor(private service: CallService, private builder: FormBuilder, private utils: UtilsService) { }

  ngOnInit(): void {
    this.form = this.builder.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    }
    );
  }


  public onSubmit() {
    

    this.loading = true;


    this.service.getcheckInfos().subscribe((data) => {
      this.data = data;
      
      this.loading = false;
    })


  }



}
